import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterOfEmploymentModalComponent } from './letter-of-employment-modal.component';
import { ButtonModule, ToggleModule } from '@xref/xref-lib';

@NgModule({
  declarations: [LetterOfEmploymentModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    ToggleModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
  exports: [LetterOfEmploymentModalComponent]
})
export class LetterOfEmploymentModalModule { }
